global.$ = global.jQuery = require("jquery");
const slick = require("slick-carousel");
require("@fancyapps/fancybox");

/*
Sticky-kit v1.1.2 | WTFPL | Leaf Corcoran 2015 | http://leafo.net
*/
(function () {
    var b, f;
    b = this.jQuery || window.jQuery;
    f = b(window);
    b.fn.stick_in_parent = function (d) {
        var A, w, J, n, B, K, p, q, k, E, t;
        null == d && (d = {});
        t = d.sticky_class;
        B = d.inner_scrolling;
        E = d.recalc_every;
        k = d.parent;
        q = d.offset_top;
        p = d.spacer;
        w = d.bottoming;
        null == q && (q = 0);
        null == k && (k = void 0);
        null == B && (B = !0);
        null == t && (t = "is_stuck");
        A = b(document);
        null == w && (w = !0);
        J = function (a, d, n, C, F, u, r, G) {
            var v, H, m, D, I, c, g, x, y, z, h, l;
            if (!a.data("sticky_kit")) {
                a.data("sticky_kit", !0);
                I = A.height();
                g = a.parent();
                null != k && (g = g.closest(k));
                if (!g.length) throw "failed to find stick parent";
                v = m = !1;
                (h = null != p ? p && a.closest(p) : b("<div />")) &&
                    h.css("position", a.css("position"));
                x = function () {
                    var c, f, e;
                    if (
                        !G &&
                        ((I = A.height()),
                        (c = parseInt(g.css("border-top-width"), 10)),
                        (f = parseInt(g.css("padding-top"), 10)),
                        (d = parseInt(g.css("padding-bottom"), 10)),
                        (n = g.offset().top + c + f),
                        (C = g.height()),
                        m &&
                            ((v = m = !1),
                            null == p && (a.insertAfter(h), h.detach()),
                            a
                                .css({
                                    position: "",
                                    top: "",
                                    width: "",
                                    bottom: "",
                                })
                                .removeClass(t),
                            (e = !0)),
                        (F =
                            a.offset().top -
                            (parseInt(a.css("margin-top"), 10) || 0) -
                            q),
                        (u = a.outerHeight(!0)),
                        (r = a.css("float")),
                        h &&
                            h.css({
                                width: a.outerWidth(!0),
                                height: u,
                                display: a.css("display"),
                                "vertical-align": a.css("vertical-align"),
                                float: r,
                            }),
                        e)
                    )
                        return l();
                };
                x();
                if (u !== C)
                    return (
                        (D = void 0),
                        (c = q),
                        (z = E),
                        (l = function () {
                            var b, l, e, k;
                            if (
                                !G &&
                                ((e = !1),
                                null != z &&
                                    (--z, 0 >= z && ((z = E), x(), (e = !0))),
                                e || A.height() === I || x(),
                                (e = f.scrollTop()),
                                null != D && (l = e - D),
                                (D = e),
                                m
                                    ? (w &&
                                          ((k = e + u + c > C + n),
                                          v &&
                                              !k &&
                                              ((v = !1),
                                              a
                                                  .css({
                                                      position: "fixed",
                                                      bottom: "",
                                                      top: c,
                                                  })
                                                  .trigger(
                                                      "sticky_kit:unbottom"
                                                  ))),
                                      e < F &&
                                          ((m = !1),
                                          (c = q),
                                          null == p &&
                                              (("left" !== r &&
                                                  "right" !== r) ||
                                                  a.insertAfter(h),
                                              h.detach()),
                                          (b = {
                                              position: "",
                                              width: "",
                                              top: "",
                                          }),
                                          a
                                              .css(b)
                                              .removeClass(t)
                                              .trigger("sticky_kit:unstick")),
                                      B &&
                                          ((b = f.height()),
                                          u + q > b &&
                                              !v &&
                                              ((c -= l),
                                              (c = Math.max(b - u, c)),
                                              (c = Math.min(q, c)),
                                              m && a.css({ top: c + "px" }))))
                                    : e > F &&
                                      ((m = !0),
                                      (b = { position: "fixed", top: c }),
                                      (b.width =
                                          "border-box" === a.css("box-sizing")
                                              ? a.outerWidth() + "px"
                                              : a.width() + "px"),
                                      a.css(b).addClass(t),
                                      null == p &&
                                          (a.after(h),
                                          ("left" !== r && "right" !== r) ||
                                              h.append(a)),
                                      a.trigger("sticky_kit:stick")),
                                m &&
                                    w &&
                                    (null == k && (k = e + u + c > C + n),
                                    !v && k))
                            )
                                return (
                                    (v = !0),
                                    "static" === g.css("position") &&
                                        g.css({ position: "relative" }),
                                    a
                                        .css({
                                            position: "absolute",
                                            bottom: d,
                                            top: "auto",
                                        })
                                        .trigger("sticky_kit:bottom")
                                );
                        }),
                        (y = function () {
                            x();
                            return l();
                        }),
                        (H = function () {
                            G = !0;
                            f.off("touchmove", l);
                            f.off("scroll", l);
                            f.off("resize", y);
                            b(document.body).off("sticky_kit:recalc", y);
                            a.off("sticky_kit:detach", H);
                            a.removeData("sticky_kit");
                            a.css({
                                position: "",
                                bottom: "",
                                top: "",
                                width: "",
                            });
                            g.position("position", "");
                            if (m)
                                return (
                                    null == p &&
                                        (("left" !== r && "right" !== r) ||
                                            a.insertAfter(h),
                                        h.remove()),
                                    a.removeClass(t)
                                );
                        }),
                        f.on("touchmove", l),
                        f.on("scroll", l),
                        f.on("resize", y),
                        b(document.body).on("sticky_kit:recalc", y),
                        a.on("sticky_kit:detach", H),
                        setTimeout(l, 0)
                    );
            }
        };
        n = 0;
        for (K = this.length; n < K; n++) (d = this[n]), J(b(d));
        return this;
    };
}).call(this);

/*
 * jQuery One Page Nav Plugin
 * http://github.com/davist11/jQuery-One-Page-Nav
 *
 * Copyright (c) 2010 Trevor Davis (http://trevordavis.net)
 * Dual licensed under the MIT and GPL licenses.
 * Uses the same license as jQuery, see:
 * http://jquery.org/license
 *
 * @version 3.0.0
 *
 * Example usage:
 * $('#nav').onePageNav({
 *   currentClass: 'current',
 *   changeHash: false,
 *   scrollSpeed: 750
 * });
 */

(function ($, window, document, undefined) {
    // our plugin constructor
    var OnePageNav = function (elem, options) {
        this.elem = elem;
        this.$elem = $(elem);
        this.options = options;
        this.metadata = this.$elem.data("plugin-options");
        this.$win = $(window);
        this.sections = {};
        this.didScroll = false;
        this.$doc = $(document);
        this.docHeight = this.$doc.height();
    };

    // the plugin prototype
    OnePageNav.prototype = {
        defaults: {
            navItems: "a",
            currentClass: "current",
            changeHash: false,
            easing: "swing",
            filter: "",
            scrollSpeed: 750,
            scrollThreshold: 0.5,
            begin: false,
            end: false,
            scrollChange: false,
            offsetTop: 0,
        },

        init: function () {
            // Introduce defaults that can be extended either
            // globally or using an object literal.
            this.config = $.extend(
                {},
                this.defaults,
                this.options,
                this.metadata
            );

            this.$nav = this.$elem.find(this.config.navItems);

            //Filter any links out of the nav
            if (this.config.filter !== "") {
                this.$nav = this.$nav.filter(this.config.filter);
            }

            //Handle clicks on the nav
            this.$nav.on("click.onePageNav", $.proxy(this.handleClick, this));

            //Get the section positions
            this.getPositions();

            //Handle scroll changes
            this.bindInterval();

            //Update the positions on resize too
            this.$win.on("resize.onePageNav", $.proxy(this.getPositions, this));

            return this;
        },

        adjustNav: function (self, $parent) {
            self.$elem
                .find("." + self.config.currentClass)
                .removeClass(self.config.currentClass);
            $parent.addClass(self.config.currentClass);
        },

        bindInterval: function () {
            var self = this;
            var docHeight;

            self.$win.on("scroll.onePageNav", function () {
                self.didScroll = true;
            });

            self.t = setInterval(function () {
                docHeight = self.$doc.height();

                //If it was scrolled
                if (self.didScroll) {
                    self.didScroll = false;
                    self.scrollChange();
                }

                //If the document height changes
                if (docHeight !== self.docHeight) {
                    self.docHeight = docHeight;
                    self.getPositions();
                }
            }, 250);
        },

        getHash: function ($link) {
            return $link.attr("href").split("#")[1];
        },

        getPositions: function () {
            var self = this;
            var linkHref;
            var topPos;
            var $target;

            self.$nav.each(function () {
                linkHref = self.getHash($(this));
                $target = $("#" + linkHref);

                if ($target.length) {
                    topPos = $target.offset().top;
                    self.sections[linkHref] = Math.round(topPos);
                }
            });
        },

        getSection: function (windowPos) {
            var returnValue = null;
            var windowHeight = Math.round(
                this.$win.height() * this.config.scrollThreshold
            );

            for (var section in this.sections) {
                if (this.sections[section] - windowHeight < windowPos) {
                    returnValue = section;
                }
            }

            return returnValue;
        },

        handleClick: function (e) {
            var self = this;
            var $link = $(e.currentTarget);
            var $parent = $link.parent();
            var newLoc = "#" + self.getHash($link);

            if (!$parent.hasClass(self.config.currentClass)) {
                //Start callback
                if (self.config.begin) {
                    self.config.begin();
                }

                //Change the highlighted nav item
                self.adjustNav(self, $parent);

                //Removing the auto-adjust on scroll
                self.unbindInterval();

                //Scroll to the correct position
                self.scrollTo(newLoc, function () {
                    //Do we need to change the hash?
                    if (self.config.changeHash) {
                        window.location.hash = newLoc;
                    }

                    //Add the auto-adjust on scroll back in
                    self.bindInterval();

                    //End callback
                    if (self.config.end) {
                        self.config.end();
                    }
                });
            }

            e.preventDefault();
        },

        scrollChange: function () {
            var windowTop = this.$win.scrollTop();
            var position = this.getSection(windowTop);
            var $parent;

            //If the position is set
            if (position !== null) {
                $parent = this.$elem
                    .find('a[href$="#' + position + '"]')
                    .parent();

                //If it's not already the current section
                if (!$parent.hasClass(this.config.currentClass)) {
                    //Change the highlighted nav item
                    this.adjustNav(this, $parent);

                    //If there is a scrollChange callback
                    if (this.config.scrollChange) {
                        this.config.scrollChange($parent);
                    }
                }
            }
        },

        scrollTo: function (target, callback) {
            var offset = $(target).offset().top - this.config.offsetTop;

            $("html, body").animate(
                {
                    scrollTop: offset,
                },
                this.config.scrollSpeed,
                this.config.easing,
                callback
            );
        },

        unbindInterval: function () {
            clearInterval(this.t);
            this.$win.unbind("scroll.onePageNav");
        },
    };

    OnePageNav.defaults = OnePageNav.prototype.defaults;

    $.fn.onePageNav = function (options) {
        return this.each(function () {
            new OnePageNav(this, options).init();
        });
    };
})(jQuery, window, document);

//main.js file

var $ = jQuery.noConflict();

/* Script on ready
------------------------------------------------------------------------------*/
$(document).ready(function () {
    /* sticky sidebar */
    if ($(window).width() > 767) {
        if ($("#in_stick").length > 0) {
            $("#in_stick").stick_in_parent();
        }
    }
    /* onepage navination */
    if ($(".anchor-scroll").length > 0) {
        $(".anchor-scroll").onePageNav({
            currentClass: "active",
        });
    }
    /* video-slider */
    if ($(".video-slider").length > 0) {
        $(".video-slider").slick({
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 2,
                    },
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    }

    $(".hamburger").click(function () {
        $(this).stop().toggleClass("isOpen");
        $(".navMenu").stop().slideToggle();
    });
});

/* Script on load
------------------------------------------------------------------------------*/
$(window).on("load", function () {
    // page is fully loaded, including all frames, objects and images
    if ($(window).width() > 767) {
        if ($("#in_stick").length > 0) {
            $("#in_stick").stick_in_parent();
        }
    }
});

/* Script on resize
------------------------------------------------------------------------------*/
$(window).on("resize", function () {
    if ($(window).width() > 767) {
        if ($("#in_stick").length > 0) {
            $("#in_stick").stick_in_parent();
        }
    }
});

$(document).ready(function () {
    // Function to activate a tab by ID
    function activateTab(tabId) {
        // Remove font-bold from all tabs
        $(".tab-btn").removeClass("font-bold");
        // Hide all tab content
        $(".tab-content > div").addClass("hidden");

        // Find the button with matching data-tab and activate it
        const $targetBtn = $(`.tab-btn[data-tab="${tabId}"]`);
        if ($targetBtn.length) {
            $targetBtn.addClass("font-bold");
            $(`#${tabId}`).removeClass("hidden");
        } else {
            // Fallback to first tab if tabId not found
            $(".tab-btn:first").addClass("font-bold");
            $(".tab-content > div:first").removeClass("hidden");
        }
    }

    // Function to get the tab from URL query parameter
    function getTabFromUrl() {
        const params = new URLSearchParams(window.location.search);
        return params.get("tab") || ""; // Return empty string if no tab param
    }

    // Set initial tab based on URL query parameter
    const initialTab = getTabFromUrl();
    if (initialTab) {
        activateTab(initialTab);
    } else {
        // Default: First tab active
        $(".tab-btn:first").addClass("font-bold");
        $(".tab-content > div:first").removeClass("hidden");
    }

    // Handle tab clicks
    $(".tab-btn").click(function (e) {
        e.preventDefault(); // Prevent default anchor behavior
        const targetTab = $(this).data("tab");
        activateTab(targetTab);

        // Update URL with query parameter, preserve existing hash (e.g., for footnotes)
        const currentHash = window.location.hash; // e.g., #note-1
        const newUrl = `${window.location.pathname}?tab=${targetTab}${currentHash}`;
        window.history.pushState({ tab: targetTab }, "", newUrl); // Update URL without reloading
    });

    // Update on popstate (browser back/forward)
    $(window).on("popstate", function () {
        const newTab = getTabFromUrl();
        if (newTab) {
            activateTab(newTab);
        } else {
            // Fallback to first tab
            $(".tab-btn:first").addClass("font-bold");
            $(".tab-content > div:first").removeClass("hidden");
        }
    });
});